import React, { Component } from "react";

export class InfoPopupComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true, // akan muncul secara default
            isVisible: false, // untuk mengontrol animasi
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({isVisible: true });
        }, 10);
    }

    handleClose = () => {
        this.setState({ isOpen: false });
    };

    render() {
        const { isOpen, isVisible } = this.state;

        if (!isOpen) return null;

        const overlayStyle = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 0.3s ease',
        };

        const popupStyle = {
            backgroundColor: '#fff',
            padding: '2rem',
            borderRadius: '12px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.4)',
            textAlign: 'center',
            position: 'relative',
            transform: isVisible ? 'scale(1)' : 'scale(0.8)',
            opacity: isVisible ? 1 : 0,
            transition: 'transform 0.3s ease, opacity 0.3s ease',
        };

        return (
            <div style={overlayStyle} onClick={this.handleClose}>
                <div style={popupStyle} onClick={(e) => e.stopPropagation()}>
                    <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}> SAPA SAMPANG SATU DATA</h3>
                    <div style={{ marginBottom: '1.5rem' }}>
                        <img src={`${process.env.PUBLIC_URL}/template/img/popup/SapaSampangSatuData.png`}
                        alt="QR Code"
                        style={{
                            width: '180px',
                            height: '180px',
                            border: '2px solid #ddd',
                            borderRadius: '8px',
                            objectFit: 'contain',
                            }}
                        />
                        <p style={{ fontSize: '0.9rem', marginTop: '0.5rem', color: '#555' }}>
                            Scan QR Code untuk info lebih lanjut!
                        </p>

                    </div>
                    <button
                    onClick={this.handleClose}
                    style={{
                        padding: '0.75rem 1.5rem',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                    }}
                    className="download-btn"
                    >
                    Close Info
                    </button>
                </div>
            </div>
        );
    }
}

export default InfoPopupComponent;